<template>
  <div>
    <!-- toasts message -->
       <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to {{confirmSms}} this package ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmModel = false"
              >Disagree</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="submitPackageDetail"
            > Agree </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-progress-circular
      v-if="Loader"
      :size="70"
      :width="7"
      color="teal"
      indeterminate
    ></v-progress-circular>

    <v-expansion-panel>
      <v-expansion-panel-content >
        <template v-slot:header>
          <div> <h2>Package Execution Details</h2> </div>
        </template>

          <pacageDetails :key="pacageDetails"></pacageDetails>

      </v-expansion-panel-content>
    </v-expansion-panel>
    

    
    

    <!--
    <table width="100%" class="tblClass">
      <tbody>     
        <tr>
          <th colspan="4" style="font-weight:bold; font-size:20px; padding:10px 0px;">Package Information</th>
        </tr>

        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>

        <tr class="textCenter">          
          <th>Package No.</th>
          <th>Package Name</th> 
          <th>Package Date</th> 
          <th>Estimated Price.</th> 
        </tr>

        <tr class="textCenter">          
          <td>{{packagesList.package_no}}</td>
          <td>{{packagesList.name}}</td>
          <td>{{(packagesList.from_date) ? changeFormateDMY(packagesList.from_date) : ''}}</td>
          <td>{{packagesList.estimated_price}}</td>
        </tr>

        <tr class="textCenter">          
          <th>Source of Fund</th>
          <th>Prior Review</th> 
          <th>Currancy Rate</th> 
          <th>Remarks.</th> 
        </tr>

        <tr class="textCenter">          
          <td>{{packagesList.fund_sources}}</td>
          <td>{{(packagesList.prior_rev == 1) ? 'Yes' : 'No'}}</td>
          <td>{{packagesList.es_currency_rate}}</td>
          <td>{{packagesList.remarks}}</td>
        </tr>


    

      </tbody>
    </table>
    -->


    <br><br>
    <div v-if="isEditable">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-layout wrap>
          <div id="auto" style="height:70vh !important">
            <table id="customers" width="100%">
              <tr>
                <th>Road Map</th>
                <th>Tentative - Start - Date</th>
                <th>Tentative - End - Date</th>
                <th>Actual - Start - Date</th>
                <th>Total Days</th>
                <th>Actual - End - Date</th>
                <th>Actual Value (BDT)</th>
                <th>Complain</th>
                <th style = "padding-right: 110px;">Remarks</th>
                <th>Supplier</th>
                <th>Document</th>

              </tr>
                <tr v-for="(item,index) in formSchema" :key="index">                
                      <th class="headcol" style="white-space:pre-wrap;!important;">
                        <b>{{item.step_name}}</b>
                      </th>
                      <td>
                      <v-menu                       
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="formSchema[index].start_date"
                          label="Tentative Start Date"
                          prepend-icon="event"
                          readonly
                          disabled
                          v-on="on"
                          
                        ></v-text-field>
                      </template>
                      <v-date-picker 
                      v-model="formSchema[index].start_date"                        
                      ></v-date-picker>
                    </v-menu>
                    
                      </td>
                      <td>
                      <v-menu                        
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="formSchema[index].end_date"
                          label="Tentative End Date"
                          prepend-icon="event"
                          
                          readonly
                          disabled
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker 
                      v-model="formSchema[index].end_date"                         
                      ></v-date-picker>
                    </v-menu>
                    
                      </td>

                      <td>
                      <v-menu
                      v-model="dateModalLt[index].dpicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="formSchema[index].actual_start_date"
                          label="Actual Start Date"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          
                          @click="setEndDate($event, index)"
                        ></v-text-field>
                      </template>
                      <v-date-picker 
                      v-model="formSchema[index].actual_start_date"
                      @input="dateModalLt[index].dpicker = false"
                      ></v-date-picker>
                    </v-menu>
                    
                      </td>
                      <td>
                        <v-text-field
                        label="Total Days"
                        v-model="formSchema[index].total_days" 
                        @input="getDays($event,index)"              
                    ></v-text-field>
                      </td>
                      <td>
                      <v-menu
                      v-model="dateModalRt[index].dpicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="formSchema[index].actual_end_date"
                          label="Actual End Date"
                          prepend-icon="event"
                          
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker 
                      v-model="formSchema[index].actual_end_date" 
                      :min="formSchema[index].actual_start_date"
                      @input="dateModalRt[index].dpicker = false"
                      @change="setDays($event, index)"
                      ></v-date-picker>
                    </v-menu>
                    
                      </td>
                      <td>
                      <v-text-field
                        label="Actual Value (BDT)"
                        v-model="formSchema[index].actual_value" 
                                        
                    ></v-text-field>
                      </td>
                      <td>
                      <v-text-field
                      label="Complain"
                      v-model="formSchema[index].complain" 
                                        
                    ></v-text-field>
                      </td>
                      <td>
                      <v-text-field
                      label="Remarks"
                      v-model="formSchema[index].remarks" 
                                        
                    ></v-text-field>
                      </td>

                      <td>
                        <v-select
                        v-if="item.is_supplier == 1"
                        label="Supplier"
                        item-text="name"
                        item-value="id"
                        v-model="formSchema[index].supplier_id"
                        :items="supplierList"
                        multiple
                        @input="setSupplier(index,formSchema[index].supplier_id)"
                      ></v-select>
                      </td>
                      <td>
                        <v-btn color="primary" @click="docNext(formSchema[index].id)">
                          <v-icon>upload</v-icon>
                        </v-btn>
                      </td>
                </tr>
            </table>
          </div>
        </v-layout>
      </v-form>
      <!-- 1:Plan,2:Execute,3:Revision,4:Merge,5:Split,6:Close/Executed,7:Cancel,8:Procured -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="submitItem(7)">
          Cancel
        </v-btn>
        <v-btn color="warning" @click="submitItem(6)">
          Close
        </v-btn>
        <v-btn color="success" @click="submitItem(2)">
          Save
        </v-btn>
        <v-btn color="warning" @click.native="home">Home</v-btn> 
      </v-card-actions>
    </div>  
  </div>
</template>

<script>
const commonService = require("../../../../services/common.service");
import Axios from 'axios';
import serverPath from '../../../../server-path/server-path';
import pacageDetails from '../ExecutionVieweDetails';

export default {
  components: {
    pacageDetails
  },
  //props:['formSchema'],
  data: () => ({
    supplierList:[],
    packagesList:[],
    valid: true,
    confirmModel:false,
    status_id:0,
    confirmSms:'',
    isEditable:true,
    dateModalRt:[
      { dpicker: false }
    ],

    dateModalLt:[
      { dpicker: false }
    ],

    e1: 0,
    show: false,
    Loader: false,
    message: "",
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    package_info_id: sessionStorage.getItem("package_info"),
    formSchema: [],
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    pacageDetails:0,
  }),

  created() {
    sessionStorage.removeItem("step_id");
    if (this.package_info_id) {
      this.loadData();
    };
    commonService.getAllData("get_supplier_info").then(res => {
      this.supplierList = res.data;
    });
  },

  methods: {
    submitItem(id) {
      if(id==2){
        this.confirmSms = "Save";
      }else if(id==7){
        this.confirmSms = "Cancel";
      }else{
        this.confirmSms = "Close";
      }
      this.status_id = id;
      this.confirmModel = true;
    },

    reloadDetails(){
      this.pacageDetails++;
    },

    setSupplier(index,id){ 
      
    },

    handleFilesUpload(id) { 
      let uploadedFiles = this.$refs.image2.files;
      let fileExtension = uploadedFiles[0].name.replace(/^.*\./, "");
      //console.log("uploadedFiles", uploadedFiles);

      let allowedExtensions = /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.png|\.PNG|\.pdf|\.doc|\.docx)$/i;
      if (!allowedExtensions.exec(uploadedFiles[0].name)) {
        this.message = "You can upload jpg, jpeg, png, pdf, doc and docx file only";
        this.snackbar = true;
        this.$refs.image2.value = "";
        this.documentFiles = [];
      } else {
        for (var i = 0; i < uploadedFiles.length; i++) {
          this.documentFiles.push(uploadedFiles[i]);
        }
      }
    },

    setEndDate(e, key){
       this.formSchema[key].actual_end_date = ""
    },
    loadData() {
      let formSchema = this.formSchema;
      let dateModalRt = this.dateModalRt;
      let dateModalLt = this.dateModalLt;

      commonService
        .getAllDataById(this.package_info_id, "proc_execution")
        .then((res) => {
          this.packagesList = res.packagesList;
          // depend on status
          (res.packagesList.status_id == 6 || res.packagesList.status_id == 7) ? this.isEditable = false : this.isEditable = true;
          if (res.data) {
            const filtered = res.data.filter(function({step_name}) {

              const key =`${step_name}`;

              return !this.has(key) && this.add(key);

            }, new Set);

            if(filtered.length>0)
            {
              filtered.forEach(function(val,key){
                dateModalRt.push({dpicker:false})
                dateModalLt.push({dpicker:false})
                  if(val.supplier_id != null){
                    filtered[key].supplier_id = JSON.parse(val.supplier_id);
                  }
              })
              this.formSchema = filtered;
            }
            
            //console.log("this.formSchema = ", this.formSchema);
          }
          this.show = true;
        });
    },

    getDays(e,key){     

      let formSchema = this.formSchema[key];

      if(e > 0 && formSchema.actual_start_date != null){
        let sdate = formSchema.actual_start_date
        let make_sys_date = new Date(sdate)
        let tempdate = make_sys_date.setDate(make_sys_date.getDate()+parseInt(e) - 1)
        let edate = new Date(tempdate)
        formSchema.actual_end_date = edate.toJSON().substring(0,10)

        this.nextStartDate(formSchema.actual_end_date, key);
      }else if (e == 0) {
        let previous;
        //recursively check previous dates.
        for (let index = key-1; index >= 0; index--) {
            if(this.formSchema[index].actual_end_date !== null) {
              previous = this.formSchema[index];
              break;
            }else {
              continue;
            }
        }
        this.setNextStartDateZeroVal(previous, key,e);
       
      }
    },

    setDays(e,key){
      
      var formSchema = this.formSchema[key];

      if(formSchema.actual_start_date != null)
      {
        let date1 = new Date(formSchema.actual_start_date); 
        let date2 = new Date(formSchema.actual_end_date); 
        let Difference_In_Time = date2.getTime() - date1.getTime();
        let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
        formSchema.total_days = (Difference_In_Days + 1)  
          
        this.nextStartDate(formSchema.actual_end_date, key);

      }

    },

    /**
     * set next step date for 0 total days
     *
    */

    setNextStartDateZeroVal (value, key,e) {
      let prviousDate = value.actual_end_date;
      let result = new Date(prviousDate);
        result.setDate(result.getDate() + 1);
      let nextdate = new Date(result);
      nextdate = nextdate.toJSON().substring(0,10);

      // console.log(nextdate.toJSON().substring(0,10))
      if(e && e == 0){
        this.formSchema[key].actual_start_date = null;
        this.formSchema[key].actual_end_date = null;
      }
      let keys = key + 1;
      this.formSchema[keys].actual_start_date = nextdate;
    },

    nextStartDate(date, key){
      var keys = key + 1;
      var formSchema = this.formSchema[keys];
      
      if(formSchema)
      {
        var result = new Date(date);
        result.setDate(result.getDate() + 1);
        var edate = new Date(result);
        formSchema.actual_start_date = edate.toJSON().substring(0,10)
        formSchema.actual_end_date = '';
        formSchema.total_days = '';
      }
    },

  
    submitPackageDetail() {
      let root = this;
      let formSchema = this.formSchema;
      formSchema[0].status_id = this.status_id;
      if (this.$refs.form.validate()) {
            commonService.updateFormData(formSchema, 'proc_execution').then(res => {							
							if(res.status == 1){
                  this.SnackbarVal.color = "success";
                  this.SnackbarVal.message = res.message;
                  this.SnackbarVal.snackbar = true;
                  // this.$refs.form.reset();
                  this.confirmModel = false;
                  (res.package_status == 6 || res.package_status == 7) ? this.isEditable = false : this.isEditable = true;
                  this.reloadDetails();
                 setTimeout(function() {
                  //root.nextStep();
                }, 3000);
							}
            });   
      }
     
    },

    docNext(id){
        this.$emit("stepDoc", id);
        this.nextStep();
    },

    nextStep() {
      this.Loader = false;
      this.$emit("emitForm1", 2);
    },

    previous() {
      this.$emit("emitForm1", 1);
    },

    close: function() {
      this.$refs.form.reset();
    },
    home() {
      this.$router.push("/procurement/package_execution");
    },

  },
};
</script>

<style scoped>

#customers {
  position: relative;
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 2px solid #ddd;
  padding: 8px;
  text-align: left;
  width:1%;
  white-space:nowrap;
}

#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background:green;
  color: white;
  overflow: hidden;
}

#auto{
  overflow-x: auto;
  width: 100%;
}
.headcol {
  position: absolute;
  width: 5em;
  left: 0;
  top: auto;
  border-top-width: 1px;
  /*only relevant for first row*/
  margin-top: -1px;
  /*compensate for top border*/
}

.headcol:before {
  content: '';
}

.tblClass{
  border-collapse: collapse;
}
.tblClass tr th,
.tblClass tr td{
  border:1px solid #CCC;
  padding:8px 0px;
}
.textCenter tr th,
.textCenter tr td,
.textCenter{
  text-align: center;  
}
</style>



// WEBPACK FOOTER //
// src/components/procurement/execution/step_forms/update.vue